import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverHighlight } from '@/utility/theme/animation';

export const Container = styled.div((props: { width?: string }) =>
  mq({
    width: ['100%', '100%', '100%', props.width || '1280px'],
    textAlign: 'center',
    margin: '0 auto',
  }),
);

export const HeldDate = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    marginTop: defaultTheme.spacing.l,
  }),
);

export const RaceProgramInfoWrapper = styled.div(() =>
  mq({
    width: '100%',
    display: ['block', 'block', 'flex', 'flex'],
  }),
);

export const ResultsNotExistText = styled.p(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    color: defaultTheme.color.grayScale.dark,
    fontSize: defaultTheme.font.size.m,
    padding: '88px 0',
    marginTop: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const TabWrapper = styled.div(() =>
  mq({
    width: ['90%', '90%', '90%', '842px'],
    margin: `0 auto ${defaultTheme.spacing.xxl}`,
  }),
);

export const BackLinkArea = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'center',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const BackLink = styled(Link)(() =>
  mq({
    display: 'inline-block',
    fontSize: defaultTheme.font.size.s,
    ...hoverHighlight,
  }),
);
